<template>
  <div>
    <px-gestao-entregas-lista-header :on-click-refresh="onClickRefresh"
                                     @change="onChangeFilters"/>
    <div class="mt-3" v-if="loading">
      <px-circular-loading/>
    </div>
    <div class="mt-3" v-if="!loading">
      <div v-if="itensSaldos.content.length === 0" class="text-center">
        <span class="title font-weight-bold">Nenhum saldo encontrado</span>
      </div>
      <template v-for="(item, index) in itensSaldos.content">
        <px-gestao-entrega-produtos-compras-item
          :key="item.id"
          outlined
          :controla-faturamento="hasControleFaturamento"
          :compra-produto="item"
          :loading="loadingMap[item.id]"
          @change="onChangeItem(item, index)"/>
      </template>
      <v-pagination
        class="mt-3"
        v-model="page"
        :length="pagesLimit"
        :total-visible="5"/>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import GestaoEntregaService from '@/modules/gestao-entregas/gestao-entrega-service';
import pxGestaoEntregaProdutosComprasItem
  from '@/modules/gestao-entregas/GestaoEntregaProdutosComprasItem.vue';
import GestaoEntregasListaHeader from '@/modules/gestao-entregas/GestaoEntregasListaHeader.vue';
import { SituacaoEntregaCompra } from 'px-business-components';
import { mapActions, mapGetters } from 'vuex';
import {
  INIT_STATE_ACTION,
  RESET_PAGINATION, SET_CURRENT_SESSION_STATE_ACTION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
} from '@/store/gestao-entrega/actions.type';
import paginationMixin from '@/mixins/pagination-mixin';

const situacoesPendentes = [
  SituacaoEntregaCompra.keys.PENDENTE.key,
  SituacaoEntregaCompra.keys.FATURADO_PARCIAL.key,
  SituacaoEntregaCompra.keys.FATURADO.key,
  SituacaoEntregaCompra.keys.ENTREGUE_PARCIAL.key,
];

const LIMIT = 20;
const PAGE = 1;

const isSituacaoPendente = situacao => situacoesPendentes.includes(situacao);

export default {
  mixins: [paginationMixin],
  data() {
    return {
      page: PAGE,
      pagesLimit: 1,
      optionsList: {
        page: PAGE,
        itemsPerPage: LIMIT,
        sortBy: '',
        sortDesc: false,
        multiSort: false,
      },
      itensSaldos: {
        content: [],
        total: 0,
      },
      loadingMap: {},
      loading: false,
    };
  },
  computed: {
    ...mapGetters('gestaoEntrega', ['stringFilter', 'stringFilterSaldo', 'listOptions']),
    ...mapGetters('entidade', ['hasControleFaturamento', 'idEntidade']),
    ...mapGetters('user', ['user']),
  },
  methods: {
    ...mapActions('gestaoEntrega', {
      resetPagination: RESET_PAGINATION,
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    getGestaoEntregasLista() {
      this.loading = true;

      this.updateFilter(this.stringFilter);
      const { limit, offset } = this.listOptions;

      return GestaoEntregaService.getItensComprasSaldos({
        query: this.buildQuery(this.listOptions),
        querySaldo: this.stringFilterSaldo,
        limit,
        offset,
      })
        .then(({ data }) => {
          this.itensSaldos = data;
          this.setPagesLimit();
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
    updateItemReference(item, index) {
      Vue.set(this.loadingMap, item.id, true);
      GestaoEntregaService.getItemCompraSaldos(item.id)
        .then(({ data }) => {
          const shouldRefresh = isSituacaoPendente(item.situacaoEntrega)
            !== isSituacaoPendente(data.situacaoEntrega);
          if (shouldRefresh) {
            this.getGestaoEntregasLista();
            return;
          }
          this.itensSaldos.content.splice(index, 1, data);
        })
        .finally(() => {
          this.loadingMap[item.id] = false;
        });
    },
    onChangeItem(item, index) {
      this.updateItemReference(item, index);
    },
    onChangeFilters() {
      this.resetPagination();
      this.page = PAGE;
      this.getGestaoEntregasLista();
    },
    onChangeOptions() {
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getGestaoEntregasLista();
    },
    setPagesLimit() {
      this.pagesLimit = Math.ceil(this.itensSaldos.total / LIMIT);
    },
    onClickRefresh() {
      this.getGestaoEntregasLista();
    },
  },
  watch: {
    page(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.optionsList.page = newValue;
      this.onChangeOptions();
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
    this.onChangeOptions();
    this.getGestaoEntregasLista();
  },
  components: {
    pxGestaoEntregaProdutosComprasItem,
    pxGestaoEntregasListaHeader: GestaoEntregasListaHeader,
  },
};
</script>
